import Button from '@/components/public/ui/Button';
import Seo from '@/components/public/Seo';

export default function NotFound() {
  return (
    <>
      <Seo title="Página não encontrada" />
      <div className="flex min-h-[70vh] items-center justify-center px-4">
        <div className="text-center">
          <p className="font-headline text-primary/25 mb-2 text-8xl font-bold">404</p>
          <h1 className="font-headline text-on-surface mb-3 text-2xl font-semibold">
            Página não encontrada
          </h1>
          <p className="text-on-surface-light mb-8">
            A página que procura não existe ou foi movida.
          </p>
          <Button variant="primary" href="/" iconAfter="arrow_forward">
            Voltar à página inicial
          </Button>
        </div>
      </div>
    </>
  );
}
